export class ComPromoterCategoryModel {
    public commissionPromoterCategoryId?:number;
    public employeeJobId?:number;
    public maxCollectAmount?:number;
    public minCollectAmount?:number;
    public promoterCategoryId?:number; 
    
    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}